export default __webpack_public_path__ + "static/media/illustration-recruit-3-w@2x.537d7a22.webp";